import { Modal, Tabs } from 'antd';
import { groupBy } from 'lodash-es';
import { FC, useMemo, useState } from 'react';

import { useInventory } from 'src/redux/hooks/useInventory';

import useSWRProductInventory from 'src/hooks/swr/useSWRProductInventory';
import useSWRProductSupplier from 'src/hooks/swr/useSWRProductSupplier';
import useSWRProducts from 'src/hooks/swr/useSWRProducts';

import CardTitle from 'src/atomic-components/atoms/CardItem/CardTitle';
import InventoryDetailPanel from 'src/atomic-components/molecules/Inventory/InventoryDetailPanel';
import InventoryHistoryPanel from 'src/atomic-components/molecules/Inventory/InventoryHistoryPanel';
import InventoryPurchaseOutboundHistoryPanel from 'src/atomic-components/molecules/Inventory/InventoryPurchaseOutboundHistoryPanel';

type InventoryDetailModalTab = 'inventory' | 'history' | 'purchase-outbound';

const InventoryHistoryDetailModal: FC = () => {
  const [tab, setTab] = useState<InventoryDetailModalTab>('inventory');
  const { inventoryId, onSetSelectedInventory } = useInventory();

  const { inventory, refresh: refreshInventory } = useSWRProductInventory(inventoryId);
  const { products, refresh: refreshProducts } = useSWRProducts(
    inventoryId ? [['inventoryId', '==', inventoryId]] : null
  );
  const { supplier } = useSWRProductSupplier(inventory?.purchaseConfig.supplierId ?? null);
  const productsMap = useMemo(() => {
    return groupBy(products, 'inventoryUnit');
  }, [products]);

  return (
    <Modal
      title={<CardTitle title={inventory?.inventoryName ?? 'error'} />}
      open={!!inventoryId}
      onCancel={() => onSetSelectedInventory(null)}
      centered
      width={'80vw'}
      styles={{
        header: {
          backgroundColor: '#f6f7f9',
        },
        content: {
          height: '80vh',
          backgroundColor: '#f6f7f9',
          display: 'flex',
          flexDirection: 'column',
        },
        body: {
          height: '100%',
          overflow: 'scroll',
        },
      }}
      footer={null}
      destroyOnClose>
      <div className='flexColumn height100 overflowHidden'>
        <Tabs
          defaultActiveKey={tab}
          activeKey={tab}
          style={{ flex: 1, overflow: 'hidden' }}
          onChange={(key) => setTab(key as InventoryDetailModalTab)}
          items={[
            {
              label: '재고 상세',
              key: 'inventory',
              children: (
                <InventoryDetailPanel
                  inventory={inventory}
                  supplier={supplier}
                  productsMap={productsMap}
                  refreshInventory={refreshInventory}
                  refreshProducts={refreshProducts}
                />
              ),
            },
            {
              label: '재고 히스토리',
              key: 'history',
              children: <InventoryHistoryPanel inventory={tab === 'history' ? inventory : undefined} />,
            },
            {
              label: '거래처 발주 히스토리',
              key: 'purchase-outbound',
              children: (
                <InventoryPurchaseOutboundHistoryPanel
                  inventory={tab === 'purchase-outbound' ? inventory : undefined}
                />
              ),
            },
          ]}
        />
      </div>
    </Modal>
  );
};

export default InventoryHistoryDetailModal;
